<div class="account">
  <span
    class="icon leftpad"
    [ngClass]="option?.policyTypeIcon"
    role="img"
    aria-label="Risk Icon"
  ></span>
  <div class="leftpad">
    {{ option?.riskDescription }}
  </div>
  <p class="leftpad account-number">Acct {{ option?.billAccountNumber | prettyBillingAcctNum }}</p>
  <!-- Alert text if any -->
  @if (option?.text) {
    <div class="warning pad-left-8">
      <span class="icon-alert"></span>
      <p class="pad-left-5 warningText" data-cy="alertText">{{ option?.text }}</p>
    </div>
  }
</div>
